import { InvoicesCardState } from "./types";

export const initState: InvoicesCardState = {
  invoice: null,
  order: null,
  payment: null,
  isLoading: false,
};
